<template>
  <h1>Welcome to let's wish</h1>
  <p>
    This is a website dedicated to making digital wishes and sharing with your
    friends.
  </p>
  <p>Currently, it only shares Christmas, New year and Birthday messages</p>
  <h2>Examples</h2>
  <p>Christmas wish <a href="https://letswish.netlify.app/x?n=coul">here</a></p>
  <p>New year wish <a href="https://letswish.netlify.app/y?n=coul">here</a></p>
  <p>Birthday wish <a href="https://letswish.netlify.app/b?n=coul">here</a></p>
  <p>
    Click <a href="/wish" class="green-link">here</a> to share a wish with
    someone special.
  </p>
  <p>Check my official website <a href="https://thatcoul.netlify.app">here</a> to share feedback or find my contacts.</p>
</template>

<script>
export default {
  name: "Home",
};
</script>